import { getAccessToken, getSubId } from '@devhacker/shared/features/auth/utils/token';
import {
  addFolder as addFolderApi,
  deleteFolder as deleteFolderApi,
  fetchFolders,
  renameFolder as renameFolderApi,
} from '@devhacker/shared/features/profile/api';

import { defineStore } from 'pinia';
import { wrapPiniaStore } from '@devhacker/shared/utils/wrapPiniaStore';

export const useFoldersStore = wrapPiniaStore(
  defineStore('folders', {
    state: () => ({
      items: [] as Array<IFolderItem>,
      total: 0,
    }),

    actions: {
      async getFolders() {
        const token = getAccessToken();
        if (!token) return;

        const subId = getSubId(token);
        if (!subId) return;

        try {
          const respFolders = await fetchFolders<{
            data: Array<{ id: number | null; name: string; favorites_count?: number }>;
            meta: { total: number };
          }>(subId);

          const items: Array<IFolderItem> = respFolders.data.map((item) => ({
            id: item.id,
            name: item.id === null ? 'Общее' : item.name,
            total: item.favorites_count ?? 0,
          }));

          this.setFolders({
            items,
            total: respFolders.meta.total,
          });
        } catch (error) {
          console.error(error);
        }
      },

      async deleteFolder(folder: IFolderItem) {
        const token = getAccessToken();
        if (!token) return;

        const subId = getSubId(token);
        if (!subId) return;

        if (folder.id === null) return;

        try {
          return await deleteFolderApi(subId, folder.id);
        } catch (error) {
          console.error(error);
        }
      },

      async addFolder(name: string) {
        const token = getAccessToken();
        if (!token) return;

        const subId = getSubId(token);
        if (!subId) return;

        try {
          return await addFolderApi(subId, name);
        } catch (error) {
          console.error(error);
        }
      },

      async renameFolder(name: string, folderId: number) {
        const token = getAccessToken();
        if (!token) return;

        const subId = getSubId(token);
        if (!subId) return;

        try {
          return await renameFolderApi(subId, folderId, name);
        } catch (error) {
          console.error(error);
        }
      },

      setFolders(folders: { items: Array<IFolderItem>; total: number }) {
        this.items = folders.items;
        this.total = folders.total;
      },

      clearFolders() {
        this.$reset();
      },
    },
  }),
);
